import { render } from "./RegisterProfile.vue?vue&type=template&id=174b730f&scoped=true"
import script from "./RegisterProfile.vue?vue&type=script&lang=js"
export * from "./RegisterProfile.vue?vue&type=script&lang=js"

import "./RegisterProfile.vue?vue&type=style&index=0&id=174b730f&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174b730f"]])

export default __exports__